import * as React from 'react';
import styled from 'styled-components';

const DEV_API_HOST = 'https://api.dev.flametask.com';

export function shouldBlockDevApi(apiHost = process.env.REACT_APP_API_HOST) {
  return normalizeApiHost(apiHost) === DEV_API_HOST;
}

export interface DevApiBlockProps {
  children: React.ReactNode;
}

export function DevApiBlock(props: DevApiBlockProps) {
  if (!shouldBlockDevApi()) {
    return <>{props.children}</>;
  }

  return (
    <Page role="status">
      <Message>
        <Title>Dev is paused</Title>
        <Subtitle>The development environment is temporarily unavailable.</Subtitle>
      </Message>
    </Page>
  );
}

function normalizeApiHost(apiHost?: string) {
  return (apiHost || '').replace(/\/+$/, '');
}

const Page = styled.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 32px;
  background: #f3f4f6;
`;

const Message = styled.div`
  text-align: center;
`;

const Title = styled.h1`
  margin: 0;
  color: #111827;
  font-size: 24px;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  margin: 10px 0 0;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.5;
`;
